module.exports = __webpack_public_path__ + "img/water.5e74b8d8.png";